import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IDevicesTabContext, DevicesTabContext } from '../../devicesTabState/devicesTabContext';
import Item from './components/Item/Item';
import classNames from 'classnames';
import style from './DevicesList.module.scss';

const DevicesList: React.FC = () => {
	const { restaurantDevices } = useContext<IDevicesTabContext>(DevicesTabContext);
	const hardwareIdHeadingClasses = classNames(style.hardwareId, style.heading);
	const terminalIdHeadingClasses = classNames(style.terminalId, style.heading);
	const tableNumberHeadingClasses = classNames(style.tableNumber, style.heading);

	return (
		<div className={style.container} data-test="DevicesList">
			<div className={style.tableHeaders}>
				<Text
					className={hardwareIdHeadingClasses}
					translationNameSpace="form"
					translationKey="hardwareIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={terminalIdHeadingClasses}
					translationNameSpace="form"
					translationKey="terminalIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={tableNumberHeadingClasses}
					translationNameSpace="form"
					translationKey="tableNumberLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{restaurantDevices.items.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};

export default DevicesList;
